import { Redirect } from "react-router";
import { Capacitor } from "@capacitor/core";

/**
 * /prodotti and /pagamento were the web checkout before the Shop. The client
 * wants one checkout to keep compliant (05/10/2026), so they now lead to the
 * Shop on the web — where the purchase confirmations live — and, as before,
 * to the Apple / Google paywall in the app.
 */
const legacyCheckoutRedirect = (webPath) => {
  const LegacyCheckoutRedirect = () => (
    <Redirect to={Capacitor.getPlatform() === "web" ? webPath : "/paywall"} />
  );
  return LegacyCheckoutRedirect;
};

/** The old plan list: Premium plans are the Shop's "Abbonamenti Premium". */
export const LegacyProductsRedirect = legacyCheckoutRedirect(
  "/shopping-widget/section/masterclub",
);

/** The old Stripe payment page. */
export const LegacyPaymentRedirect = legacyCheckoutRedirect("/shopping-widget");
